// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2yKNr","selected":"Chip_selected__2qdcT"};